<template>
     
        <div class="form_group">
            <label v-if="showLabel" class="form_label d-flex">{{label}}</label>

            <template v-if="isCallFromQrcode">
                <div v-for="(digit, index) in qrOtpArray" :key="index" class="otp-input">
                <input
                    oninput="this.value = this.value.replace(/[^0-9]/g, '').replace(/(\..*)\./g, '$1'); this.value = this.value.replace(/ /g,'');"
                    type="text"
                    maxlength="1"
                    v-model="otpArray[index]"
                    @input="onInput(index, $event)"
                    @keydown.backspace="onBackspace(index, $event)"
                    ref="otpInput"
                    :disabled='isDisabled'
                />
                </div>
            </template>

            <template v-else>
            <div v-for="(digit, index) in otpArray" :key="index" class="otp-input">
                <input
                    oninput="this.value = this.value.replace(/[^0-9]/g, '').replace(/(\..*)\./g, '$1'); this.value = this.value.replace(/ /g,'');"
                    type="text"
                    maxlength="1"
                    v-model="otpArray[index]"
                    @input="onInput(index, $event)"
                    @keydown.backspace="onBackspace(index, $event)"
                    ref="otpInput"
                    :disabled='isDisabled' class="booking_otp"
                />
                </div>
            </template>
           
        </div>
    
    </template>
    
    <script>
import { type } from '@amcharts/amcharts4/core';

 
    export default {
        inject: ["parentValidator"],
        data(){
            return {
                otpArray:['', '', '', ''],
                qrOtpArray:['', '', '', '','', '']
            }
        },
        props:{
            value:null,
            isDisabled:{
                type:Boolean,
                default:false
            },
            fieldName:{
                type:String,
                default:''
            },
            cid:{
                type:String,
                default:''
            },
            length: {
                type: Number,
                required: true
            },
            label:{
                type:String,
                default:''
            },
            wrapclass:{
                type:String,
                default:"md:w-1/2"
            },
            showLabel:{
                type:Boolean,
                default:true
            },
            isCallFromQrcode:{
                type:Boolean,
                default:false
            }
        },
        created() {
            this.$validator = this.parentValidator;
        },
        methods: {
            onInput(index, event) {
                const value = event.target.value;
                if (/^\d$/.test(value)) {
                    this.updateOtp(index, value);
                    if (index < this.length - 1) {
                        if (this.$refs.otpInput[index + 1]) {
                            this.$refs.otpInput[index + 1].focus();
                        }
                    }
                } else {
                    this.updateOtp(index, '');
                }
            },
            onBackspace(index, event) {
                if (!this.otpArray[index]) {
                    if (this.$refs.otpInput[index - 1]) {
                        this.$refs.otpInput[index - 1].focus();
                    }
                }
                this.updateOtp(index, '');
            },
            updateOtp(index, value) {
                const otp = this.otpArray.slice();
                otp[index] = value;
                this.$emit('input', otp.join(''));
            }
        },
        components: {

        },
        mounted() {

        },
        computed:{}
    };
    </script>

    <style>

.right_section .otp_four_digits .otp_val .otp-input{
    width: 50px;
    height: 46px;
    margin-right: 10px;
}
.right_section .otp_four_digits .otp_val .otp-input .booking_otp{
    width: 50px;
    height: 46px;
    border-radius: 4px;
    text-align: center;
    font-size: 20px;
    font-weight: 700;
    border: 1px solid var(--color-grey-3,#CCCCCC);
    font-family: "DM Sans", sans-serif;
}
</style>
    